import { textChooser } from "../../common/util/textChooser";
import "./notFound.scss";

export const NotFound = () => {
    return(
        <div className="page -not_found">
            <div className="notice">
                <h1>404</h1>
                <h3>{textChooser("txt85")}</h3>
                <p>{textChooser("txt86")}</p>

                <div></div>
            </div>
        </div>
    )
}